import React, { useContext, useMemo } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { SignupViewContext } from "components/Signup.page";
import LoginIcon from "images/loginIcon.png";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import {
	Grid,
	Checkbox,
	FormControl,
	FormControlLabel,
	CircularProgress,
	FormLabel,
	TextField,
	IconButton,
	InputAdornment,
	Button,
	MenuItem,
} from "@mui/material";
import LoadingScreen from "components/common/LoadingScreen";
import LockPromptDialog from "components/common/LockPromptDialog";
import { Controller } from "react-hook-form";
import { useStyles } from "./Signup.page.style";
import { SALUTATION_LIST } from "constant";
import { AgreementDialog } from "components/common/index";

const SignupPC = () => {
	const {
		register,
		isLoading,
		theme,
		logoLink,
		handleSubmit,
		onSubmit,
		control,
		errors,
		handleClickShowPassword,
		handleClickShowConfirmPassword,
		handleMouseDownPassword,
		showPassword,
		showConfirmPassword,
		showLockTip,
		setShowLockTip,
		lockTipContent,
		loginRemainTime,
		agreePICS,
		handleChangeAgreePICS,
		specifyVisible,
		clearErrors,
		orgList,
		goBack,
		handleSignupSuccess,
		setValue,
		openAgreement,
		onCloseAgreement,
		handleClickAgreement,
		handleAgree,
		agreementTitle,
		agreementContent,
		canAgree,
		timeLeft,
	} = useContext(SignupViewContext);
	const classes = useStyles();

	const checkBoxLabel = () => {
		return (
			<div>
				I accept and agree to the{" "}
				<Grid type="text" className={classes.agreement} onClick={handleClickAgreement}>
					Personal Information Collection Statement
				</Grid>
				.
			</div>
		);
	};

	return (
		<div style={{ height: "100vh" }}>
			<LoadingScreen open={isLoading} />
			<StyledEngineProvider injectFirst>
				<ThemeProvider theme={theme}>
					<Grid className={`${classes.rightWrapper} ${classes.fullHeight}`}>
						<Grid container>
							<a href={logoLink} target={"_blank"}>
								<img src={LoginIcon} alt={"icon"} className={classes.loginIcon} />
							</a>
						</Grid>
						<Grid container className={classes.iconDivider}></Grid>
						<form
							autoComplete="off"
							onSubmit={handleSubmit(onSubmit)}
							className={classes.loginFormContainer}
						>
							<Grid item container direction={"column"} alignItems="center" className={classes.signuBox}>
								<div className={classes.welcomeFont}>Sign up</div>
								<Grid item spacing={2} container className={classes.infoInputBox}>
									<Grid item xs={4}>
										{/* Salutation */}
										<FormControl fullWidth className={classes.InfoLineItem}>
											<FormLabel htmlFor="salutation" className={classes.inputInfoTitle}>
												Salutation
											</FormLabel>
											<Controller
												render={({ field }) => (
													<TextField
														select
														{...field}
														{...register("salutation")}
														error={!!errors?.salutation}
														helperText={errors?.salutation?.message}
														InputProps={{
															className: classes.inputInfoStyle,
														}}
														fullWidth
													>
														{SALUTATION_LIST.map((item) => {
															return (
																<MenuItem key={item} value={item}>
																	{item}
																</MenuItem>
															);
														})}
													</TextField>
												)}
												id={"salutation"}
												name="salutation"
												control={control}
											/>
										</FormControl>
									</Grid>
									{/* Last Name */}
									<Grid item xs={4}>
										<FormControl fullWidth className={classes.InfoLineItem}>
											<FormLabel htmlFor="lastName" className={classes.inputInfoTitle}>
												Last Name*
											</FormLabel>
											<Controller
												render={({ field }) => (
													<TextField
														{...field}
														{...register("lastName")}
														error={!!errors?.lastName}
														helperText={errors?.lastName?.message}
														InputProps={{
															className: classes.inputInfoStyle,
														}}
														inputProps={{ maxLength: 50 }}
														fullWidth
													/>
												)}
												id={"lastName"}
												name="lastName"
												control={control}
												rules={{
													required: true,
												}}
											/>
										</FormControl>
									</Grid>
									{/* First Name */}
									<Grid item xs={4}>
										<FormControl fullWidth className={classes.InfoLineItem}>
											<FormLabel htmlFor="firstName" className={classes.inputInfoTitle}>
												First Name*
											</FormLabel>
											<Controller
												render={({ field }) => (
													<TextField
														{...field}
														{...register("firstName")}
														error={!!errors?.firstName}
														helperText={errors?.firstName?.message}
														InputProps={{
															className: classes.inputInfoStyle,
														}}
														inputProps={{ maxLength: 50 }}
														fullWidth
													/>
												)}
												id={"firstName"}
												name="firstName"
												control={control}
												rules={{
													required: true,
												}}
											/>
										</FormControl>
									</Grid>
									<Grid item xs={12}>
										<div className={classes.nameTips}>
											<div className={classes.inputInfoTitle}></div>
											<div>
												*Your name should be the same as the one in your Hong Kong
												Identification Card (HKID Card) / Travelling Document.
											</div>
										</div>
									</Grid>
									{/* Email */}
									<Grid item xs={8}>
										<FormControl fullWidth className={classes.InfoLineItem}>
											<FormLabel htmlFor="email" className={classes.inputInfoTitle}>
												Institution Email
											</FormLabel>
											<Controller
												render={({ field }) => (
													<TextField
														{...field}
														error={!!errors?.email}
														helperText={errors?.email?.message}
														InputProps={{
															className: classes.inputInfoStyle,
														}}
														inputProps={{ maxLength: 60 }}
														fullWidth
													/>
												)}
												id={"email"}
												name="email"
												control={control}
												rules={{
													required: true,
												}}
											/>
										</FormControl>
									</Grid>

									{/* Institution */}
									<Grid item xs={8}>
										<FormControl fullWidth className={classes.InfoLineItem}>
											<FormLabel htmlFor="organizationId" className={classes.inputInfoTitle}>
												Institution
											</FormLabel>
											<Controller
												render={({ field }) => (
													<TextField
														select
														{...field}
														{...register("organizationId")}
														error={!!errors?.organizationId}
														helperText={errors?.organizationId?.message}
														InputProps={{
															className: classes.inputInfoStyle,
														}}
														fullWidth
													>
														{orgList.map((item) => {
															return (
																<MenuItem key={item.id} value={item.id}>
																	{item.name}
																</MenuItem>
															);
														})}
													</TextField>
												)}
												id={"organizationId"}
												name="organizationId"
												control={control}
												rules={{
													required: true,
												}}
											/>
										</FormControl>
									</Grid>
									{/* Specify */}

									{specifyVisible && (
										<Grid item xs={8}>
											<FormControl fullWidth className={classes.InfoLineItem}>
												<FormLabel htmlFor="specify" className={classes.inputInfoTitle}>
													Please specify
												</FormLabel>
												<Controller
													render={({ field }) => (
														<TextField
															{...field}
															{...register("specify")}
															error={!!errors?.specify}
															helperText={errors?.specify?.message}
															InputProps={{
																className: classes.inputInfoStyle,
															}}
															inputProps={{ maxLength: 100 }}
															fullWidth
														/>
													)}
													id={"specify"}
													name="specify"
													control={control}
												/>
											</FormControl>
										</Grid>
									)}
									{/* Faculty/Dept */}
									<Grid item xs={8}>
										<FormControl fullWidth className={classes.InfoLineItem}>
											<FormLabel htmlFor="dept" className={classes.inputInfoTitle}>
												Faculty/Dept
											</FormLabel>
											<Controller
												render={({ field }) => (
													<TextField
														{...field}
														{...register("dept")}
														error={!!errors?.dept}
														helperText={errors?.dept?.message}
														InputProps={{
															className: classes.inputInfoStyle,
														}}
														inputProps={{ maxLength: 100 }}
														fullWidth
													/>
												)}
												id={"dept"}
												name="dept"
												control={control}
											/>
										</FormControl>
									</Grid>
									{/* Affiliation Type */}
									<Grid item xs={4}>
										<FormControl fullWidth className={classes.InfoLineItem}>
											<FormLabel htmlFor="affiliationType" className={classes.inputInfoTitle}>
												Affiliation Type
											</FormLabel>
											<Controller
												render={({ field }) => (
													<TextField
														select
														{...field}
														{...register("affiliationType")}
														error={!!errors?.affiliationType}
														helperText={errors?.affiliationType?.message}
														InputProps={{
															className: classes.inputInfoStyle,
														}}
														fullWidth
													>
														<MenuItem value="Staff">Staff</MenuItem>
														<MenuItem value="Student">Student</MenuItem>
													</TextField>
												)}
												id={"affiliationType"}
												name="affiliationType"
												control={control}
											/>
										</FormControl>
									</Grid>
									<Grid item xs={12} className={classes.nameTipsBox}>
										<div className={classes.nameTips}>
											<div className={classes.inputInfoTitle}></div>
											<div>(No abbreviation)</div>
										</div>
									</Grid>
									{/* Job Title */}
									<Grid item xs={6}>
										<FormControl fullWidth className={classes.InfoLineItem}>
											<FormLabel htmlFor="jobTitle" className={classes.inputInfoTitle}>
												Job Title
											</FormLabel>
											<Controller
												render={({ field }) => (
													<TextField
														{...field}
														{...register("jobTitle")}
														error={!!errors?.jobTitle}
														helperText={errors?.jobTitle?.message}
														type={"text"}
														InputProps={{
															className: classes.inputInfoStyle,
														}}
														inputProps={{ maxLength: 50 }}
														fullWidth
													/>
												)}
												id={"jobTitle"}
												name="jobTitle"
												control={control}
											/>
										</FormControl>
									</Grid>
									{/* Student/Staff Card Number */}
									<Grid item xs={6}>
										<FormControl fullWidth className={classes.InfoLineItem}>
											<FormLabel htmlFor="cardNumber" className={classes.inputInfoTitle}>
												Student/Staff ID No.
											</FormLabel>
											<Controller
												render={({ field }) => (
													<TextField
														{...field}
														{...register("cardNumber")}
														error={!!errors?.cardNumber}
														helperText={errors?.cardNumber?.message}
														type={"text"}
														InputProps={{
															className: classes.inputInfoStyle,
														}}
														inputProps={{ maxLength: 30 }}
														fullWidth
													/>
												)}
												id={"cardNumber"}
												name="cardNumber"
												control={control}
											/>
										</FormControl>
									</Grid>
									<Grid item xs={12} className={classes.nameTipsBox}>
										<div className={classes.nameTips}>
											<div className={classes.inputInfoTitle}></div>
											<div>eg. PhD Student, Researcher Assistant, Professor (no abbreviation)</div>
										</div>
									</Grid>
									{/* Phone Number* */}
									<Grid item xs={8}>
										<FormControl fullWidth className={classes.InfoLineItem}>
											<FormLabel htmlFor="mobileNumber" className={classes.inputInfoTitle}>
												Phone Number
											</FormLabel>
											<Controller
												render={({ field }) => (
													<TextField
														{...field}
														{...register("countryCode")}
														error={!!errors?.countryCode}
														helperText={errors?.countryCode?.message}
														type={"text"}
														InputProps={{
															className: classes.inputInfoStyle,
														}}
														inputProps={{ maxLength: 8 }}
														sx={{ width: "28%", mr: 1 }}
													/>
												)}
												id={"countryCode"}
												name="countryCode"
												control={control}
												rules={{
													required: true,
												}}
											/>
											<Controller
												render={({ field }) => (
													<TextField
														{...field}
														{...register("mobileNumber")}
														error={!!errors?.mobileNumber}
														helperText={errors?.mobileNumber?.message}
														type={"text"}
														InputProps={{
															className: classes.inputInfoStyle,
														}}
														inputProps={{ maxLength: 20 }}
														sx={{ width: "70%" }}
													/>
												)}
												id={"mobileNumber"}
												name="mobileNumber"
												control={control}
												rules={{
													required: true,
												}}
											/>
										</FormControl>
									</Grid>
									<Grid item xs={12}>
										<FormControlLabel
											label={checkBoxLabel()}
											className={classes.controlLabel}
											control={
												<Checkbox
													size="small"
													checked={agreePICS}
													color="primary"
													sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
													onChange={handleChangeAgreePICS}
												/>
											}
										/>
									</Grid>
								</Grid>

								<Grid container justifyContent="center">
									<Grid item className={classes.LoginInputWrapper}>
										<FormControl>
											<Button
												type="submit"
												variant="contained"
												color="primary"
												style={{
													textTransform: "none",
													fontFamily: "Quicksand-SemiBold",
													fontSize: 16,
												}}
												disabled={!agreePICS}
											>
												Sign up
												{loginRemainTime > 0 ? <CircularProgress size={16} /> : null}
											</Button>
										</FormControl>
									</Grid>
									<Grid item className={classes.LoginInputWrapper}>
										<Button
											variant="contained"
											color="primary"
											style={{
												textTransform: "none",
												fontFamily: "Quicksand-SemiBold",
												fontSize: 16,
											}}
											onClick={() => {
												goBack();
											}}
										>
											Cancel
										</Button>
									</Grid>
								</Grid>
							</Grid>
						</form>
					</Grid>
				</ThemeProvider>
			</StyledEngineProvider>
			<LockPromptDialog open={showLockTip} onClose={handleSignupSuccess} content={lockTipContent} />
			<AgreementDialog
				open={openAgreement}
				onClose={onCloseAgreement}
				title={agreementTitle}
				content={agreementContent}
				onAgree={handleAgree}
				canAgree={canAgree}
				timeLeft={timeLeft}
			/>
		</div>
	);
};

export default SignupPC;
